const baseURL = process.env.VUE_APP_API_URL || 'http://localhost:5000' ||'https://lts-test.mobivention.eu'
const version = process.env.VUE_APP_VERSION || '1.0.0'


export default {
    baseURL: baseURL,
    apiUrl: `${baseURL}/vue_api/`,
    version: version
}
